import type { ReactNode } from 'react'
import { IconButton } from '@/components/IconButton'
import styles from './QuestionGeneralEditor.module.css'

export interface QuestionFieldRowProps {
  /**
   * The field that takes the remaining width.
   */
  children?: ReactNode
  /**
   * A narrow field after it, like an amount.
   */
  aside?: ReactNode
}

/**
 * Two fields side by side.
 */
export function QuestionFieldRow({ children, aside }: QuestionFieldRowProps) {
  return (
    <div className={styles.row}>
      <div className={styles.main}>{children}</div>
      <div className={styles.aside}>{aside}</div>
    </div>
  )
}

export interface QuestionOptionRowProps {
  /**
   * The option's fields, side by side.
   */
  children?: ReactNode
  onRemove: () => unknown
  removeLabel: string
  isDisabled?: boolean
  testId?: string
}

/**
 * An option of a question, like a select's, with a remove button.
 */
export function QuestionOptionRow({
  children,
  onRemove,
  removeLabel,
  isDisabled,
  testId,
}: QuestionOptionRowProps) {
  return (
    <div className={styles.option} data-test={testId}>
      <div className={styles.optionFields}>{children}</div>
      {!isDisabled && (
        <span className={styles.optionRemove}>
          <IconButton
            name="close"
            label={removeLabel}
            size={14}
            onPress={onRemove}
            testId={testId && `${testId}-remove-button`}
          />
        </span>
      )}
    </div>
  )
}
